(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/navbig/assets/javascripts/models/nav-big-statistics-model.js') >= 0) return;  svs.modules.push('/components/statistics/navbig/assets/javascripts/models/nav-big-statistics-model.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.models = svs.statistics.big.models || {};

  svs.statistics.big.models.NavBigStatisticsModel = Backbone.Model.extend({
    defaults: function() {
      return {
        showBackButton: false,
        showCloseButton: true,
        currentLabel: 'Tillbaka',
        history: []
      };
    }
  });
})(Backbone, _, svs);

 })(window);